import { createAuthClient } from "better-auth/react";
import { stripeClient } from "@better-auth/stripe/client";
import { BACKEND_URL } from "./constant";

export const client = createAuthClient({
  baseURL: `${BACKEND_URL}/auth`,
  plugins: [
    stripeClient({
      subscription: true,
    }),
  ],
});

export const upgradeSubscription = async () => {
  await client.subscription.upgrade({
    plan: "Pro",
    successUrl: "/dashboard",
    cancelUrl: "/pricing",
  });
};

export const getSubscription = async () => {
  const subscriptions = await client.subscription.list();
  return subscriptions;
};

export const { signUp, signIn, signOut, useSession } = client;

client.$store.listen("$sessionSignal", async () => { });
